// extracted by mini-css-extract-plugin
module.exports = {"label":"label-1uxWc","active":"active-Xejl3","radio":"radio-thIxu","stepChoosed":"stepChoosed-3pXUs"};